module.exports = __webpack_public_path__ + "static/media/my-cart.9b4da0f3.svg";